module.exports = __webpack_public_path__ + "media/assets/images/flags/ne-adad44e614eec04baa954d415133a967.svg";